import { Success as NewSuccess } from 'lease-signing-flow-v2/pages/success/success';

export const SignedLeaseNewSuccessPage = () => {
  return <NewSuccess />;
};
